import { Box, Typography } from "@mui/material";
import FadeInBox from "../../../../commonComponents/FadeInBox";
import map from "../../../../assets/map.png";

const WhyUs = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        pl: { xs: 4, md: 15 },
        pr: { xs: 4, md: 15 },
        rowGap: 2,
      }}
    >
      <FadeInBox
        delay={0}
        duration={1.2}
        translateY={20}
        triggerOnScroll={true}
        triggerOnMount={false}
      >
        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "25px", md: "30px" },
            fontWeight: 700,
            fontFamily: "Montserrat",
            textAlign: "center",
          }}
        >
          Global Markets & Network{" "}
        </Typography>
      </FadeInBox>
      <FadeInBox
        delay={0.2}
        duration={1.2}
        translateY={20}
        triggerOnScroll={true}
        triggerOnMount={false}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            component="img"
            src={map}
            alt="Global Markets & Network"
            sx={{
              width: { xs: "100%", md: "80%" },
              maxWidth: 900,
              height: "auto",
              display: "block",
              mx: "auto",
            }}
          />
        </Box>
      </FadeInBox>
      <Box
        sx={{
          maxWidth: { md: "900px" },
          display: "flex",
          flexDirection: "column",
          rowGap: 3,
          justifyContent: "center",
          alignItems: "center",
          mx: "auto",
          width: "100%",
        }}
      >
        <FadeInBox
          delay={0.4}
          duration={1.2}
          translateY={20}
          triggerOnScroll={true}
          triggerOnMount={false}
        >
          <Typography
            sx={{
              fontSize: { xs: "15px", md: "20px" },
              fontWeight: 500,
              fontFamily: "Montserrat",
              textAlign: "center",
            }}
          >
            <span style={{ fontWeight: 700, color: "#164B7C" }}>
              {" "}
              El Deeb for Import, Export & TA Limited{" "}
            </span>
            is a UK import, export, and trading company supplying a wide range
            of medical and commercial products.
          </Typography>
        </FadeInBox>
        <FadeInBox
          delay={0.6}
          duration={1.2}
          translateY={20}
          triggerOnScroll={true}
          triggerOnMount={false}
        >
          <Typography
            sx={{
              fontSize: { xs: "15px", md: "20px" },
              fontWeight: 500,
              fontFamily: "Montserrat",
              textAlign: "center",
            }}
          >
            We manage{" "}
            <span style={{ fontWeight: 700 }}>
              sourcing, sales, coordination, and negotiation
            </span>{" "}
            with trusted Suppliers and manufacturers to supply{" "}
            <span style={{ fontWeight: 700 }}>
              hospitals, healthcare providers, and distributors in many sectors{" "}
            </span>
            across both{" "}
            <span style={{ fontWeight: 700 }}>UK and global markets.</span>
          </Typography>
        </FadeInBox>
        <FadeInBox
          delay={0.8}
          duration={1.2}
          translateY={20}
          triggerOnScroll={true}
          triggerOnMount={false}
        >
          <Typography
            sx={{
              fontSize: { xs: "15px", md: "20px" },
              fontWeight: 500,
              fontFamily: "Montserrat",
              textAlign: "center",
            }}
          >
            All{" "}
            <span style={{ fontWeight: 700 }}>
              key commercial activities, client relationships, and supply
              management are controlled and executed through our UK operations{" "}
            </span>
            , supporting both <span style={{ fontWeight: 700 }}>domestic</span>{" "}
            distribution and{" "}
            <span style={{ fontWeight: 700 }}>international trade.</span>
          </Typography>
        </FadeInBox>
      </Box>
    </Box>
  );
};
export default WhyUs;
